import { useCallback } from 'react';
import { useApolloClient } from '@frameio/graphql-client';
import type {
  ShareNameFragment,
  UpdateShareInput,
} from '@frameio/graphql-client/generated';
import {
  ShareName,
  useUpdateShareNameMutation,
} from '@frameio/graphql-client/generated';

type UpdateShareNameArgs = Pick<UpdateShareInput, 'shareId' | 'name'>;

export const useUpdateShareName = () => {
  const [updateShare] = useUpdateShareNameMutation();
  const client = useApolloClient();

  const updateShareName = useCallback(
    ({ shareId, name }: UpdateShareNameArgs) => {
      const currentShare = client.readFragment<ShareNameFragment>({
        fragment: ShareName,
        fragmentName: 'ShareName',
        id: client.cache.identify({ __typename: 'Share', id: shareId }),
      });

      if (currentShare?.name === name) {
        return;
      }

      updateShare({
        variables: { shareId, name },
        optimisticResponse: () => ({
          updateShare: {
            __typename: 'UpdateSharePayload',
            share: {
              __typename: currentShare?.__typename,
              id: shareId,
              name,
            },
          },
        }),
      });
    },
    [client, updateShare]
  );

  return updateShareName;
};
